<div style="height: 100%;">
    <form [formGroup]="shippingStatusForm" style="height: 100%;" (ngSubmit)="saveClick()">
        <div style="height: 10%;background-color: rgb(63,81,181);color: rgba(255,255,255,0.87);">
            <h2 class="headerName">{{shipping.shippingStatus}}</h2>
        </div>

        <div style="height: 80%; padding: 1%;overflow: auto;">
            <div
                *ngIf="shipping.shippingStatus == constant.DELIVERY_PICK_UP || shipping.shippingStatus == constant.DELIVERY_PICK_UP_CANCELLED">
                <div fxLayout="row" fxLayout.lt-sm="column">
                    <mat-card class="contain_card" fxFlex="49">
                        <mat-form-field>
                            <input matInput type="text" placeholder="Location Name " formControlName="locationName"
                                readonly>
                        </mat-form-field>
                    </mat-card>

                    <mat-card class="contain_card" fxFlex="49">
                        <mat-form-field>
                            <input matInput type="number" placeholder="No Of Products " formControlName="noOfProducts"
                                readonly>
                        </mat-form-field>
                    </mat-card>
                </div>
                <div fxLayout="row" fxLayout.lt-sm="column">
                    <mat-card class="contain_card" fxFlex="49">
                        <mat-form-field>
                            <input matInput type="number" placeholder="Total Qty " formControlName="qty" readonly>
                        </mat-form-field>
                    </mat-card>

                    <mat-card class="contain_card" fxFlex="49">
                        <mat-form-field>
                            <input matInput type="number" placeholder="Total Packets " formControlName="packets">
                        </mat-form-field>
                    </mat-card>
                </div>
            </div>

            <div fxLayout="row" fxLayout.lt-sm="column" class="flex">
                <mat-card *ngIf="shipping.shippingStatus == constant.DELIVERY_PICK_UP_CANCELLED" class="contain_card"
                    fxFlex="49">
                    <mat-form-field class="field-full-width">
                        <mat-select class="field-full-width" placeholder="Reason For Cancellation"
                            formControlName="reasonCode">
                            <mat-option *ngFor="let c of reasonsOfPickupCancel" [value]="c.refNo">
                                {{c.reason}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-card>

                <mat-card *ngIf="shipping.shippingStatus == constant.DELIVERY_RESCHEDULE" class="contain_card"
                    fxFlex="49">
                    <mat-form-field class="field-full-width">
                        <mat-select class="field-full-width" placeholder="Reason For Reschedule"
                            formControlName="reasonCode">
                            <mat-option *ngFor="let c of reasonsOfReschedule" [value]="c.refNo">
                                {{c.reason}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-card>

                <mat-card *ngIf="shipping.shippingStatus == constant.DELIVERY_RESCHEDULE" class="contain_card"
                    fxFlex="49">
                    <mat-form-field>
                        <input matInput [matDatepicker]="picker" placeholder="Choose date" (click)="picker.open()"
                            formControlName="rescheduleDate" [min]="today" readonly>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </mat-card>

                <mat-card *ngIf="shipping.shippingStatus == constant.DELIVERY_RESCHEDULE" class="contain_card"
                    fxFlex="49">
                    <mat-form-field class="time_picker_container">
                        <input matInput placeholder="Choose Time" [disableClick]="false" [format]="24"
                            [ngxTimepicker]="time1" formControlName="rescheduleTime" readonly>
                        <ngx-material-timepicker-toggle [for]="time1" style="margin-top:-5px">
                        </ngx-material-timepicker-toggle>
                        <ngx-material-timepicker #time1></ngx-material-timepicker>
                    </mat-form-field>
                </mat-card>

                <mat-card *ngIf="shipping.shippingStatus == constant.DELIVERY_CANCEL" class="contain_card" fxFlex="49">
                    <mat-form-field class="field-full-width">
                        <mat-select class="field-full-width" placeholder="Reason For Cancellation"
                            formControlName="reasonCode">
                            <mat-option *ngFor="let c of reasonsOfCancellation" [value]="c.refNo">
                                {{c.reason}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-card>

                <mat-card *ngIf="shipping.shippingStatus != constant.DELIVERY_PICK_UP" class="contain_card" fxFlex="49">
                    <mat-form-field>
                        <input matInput type="text" placeholder="Notes " formControlName="notes">
                    </mat-form-field>
                </mat-card>
            </div>

            <!-- <div *ngIf="shipping.shippingStatus == constant.DELIVERY_RESCHEDULE" fxLayout="row" fxLayout.lt-sm="column">
                <mat-card class="contain_card" fxFlex="49">
                    <mat-form-field>
                        <input matInput [matDatepicker]="picker" placeholder="Choose date" (click)="picker.open()"
                            readonly>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </mat-card>
                <mat-card class="contain_card" fxFlex="49">
                    <mat-form-field class="time_picker_container">
                        <input matInput placeholder="Choose Time" [disableClick]="false" [format]="24"
                            [ngxTimepicker]="time1" readonly>
                        <ngx-material-timepicker-toggle [for]="time1" style="margin-top:-5px">
                        </ngx-material-timepicker-toggle>
                        <ngx-material-timepicker #time1></ngx-material-timepicker>
                    </mat-form-field>
                </mat-card>
            </div> -->
        </div>

        <div class="shipping_div_btn_status">
            <button type="submit" id="shipping_btn_status">
                {{shipping.shippingStatus}}
            </button>
        </div>

    </form>
</div>